module.exports = __webpack_public_path__ + "static/media/order_product_img.df6a069e.svg";